import React from "react"
import {
  DeliveredOperation,
  Operation,
  OperationWrapper,
  PlacedOperation,
  RefundedOperation,
  ReleasedOperation
} from "./OrderLine.styled"
import { Order, OrderGift, OrderHistory } from "lib/types/generated/graphql-types"
import { OrderHistoryOperations } from "../../../classes/order/OrderHistoryOperations"
import { Cancellations } from "../../../classes/order/Cancellations"

type Props = {
  gift: OrderGift
  orderHistory: OrderHistory
  order: Order
}

const OrderLineOperations = ({ gift, orderHistory, order }: Props) => {
  const orderOperations = new OrderHistoryOperations(orderHistory?.operations)
  const cancellation = new Cancellations(order.Cancellations)

  const deliveredGift = orderOperations.getDeliveredGift(gift.id)
  const refundedGift = orderOperations.getRefundedGift(gift.id)
  const releasedGift = orderOperations.getReleasedGift(gift.id)

  const cancelledOrder = cancellation.orderCancelled(order.id)

  const getOperation = () => {
    if (refundedGift) return <RefundedOperation>Returned</RefundedOperation>
    if (deliveredGift) return <DeliveredOperation>Delivered</DeliveredOperation>
    if (releasedGift) return <ReleasedOperation>Released</ReleasedOperation>
    if (cancelledOrder) return <RefundedOperation>Cancelled</RefundedOperation>
    return <PlacedOperation>Placed</PlacedOperation>
  }

  return (
    <OperationWrapper>
      <div>
        <Operation>Gift</Operation>
      </div>
      <div>{getOperation()}</div>
    </OperationWrapper>
  )
}

export default OrderLineOperations
